export const enumMap = {
    status: [
        {
            label: "启用", value: 1   
        },
        {
            label: "禁用", value: 0
        }
    ]
}